<div class="flex h-full w-full overflow-hidden">
  <!-- Files grid: visible only on xl+ screens, takes remaining space -->
  <div class="hidden min-w-0 overflow-hidden xl:flex xl:flex-1">
    <sia-ai-files-grid class="flex-1 overflow-hidden"></sia-ai-files-grid>
  </div>

  <!-- Resize handle: visible only on xl+ screens -->
  <div
    class="hidden w-2 cursor-ew-resize items-center justify-center bg-[var(--mat-sys-outline-variant)] transition-colors hover:bg-[var(--mat-sys-outline)] active:bg-[var(--mat-sys-on-surface-variant)] xl:flex"
    (mousedown)="onResizeStart($event)"
    (touchstart)="onResizeStart($event)"
  ></div>

  <!-- AI Chat: always visible, full width on mobile, resizable on xl+ -->
  <div
    class="relative min-w-0 overflow-hidden"
    [class.flex-1]="!chatWidth()"
    [class.xl:w-[30%]]="!chatWidth()"
    [style.width.px]="chatWidth()"
  >
    <sia-ai-chat
      [forceEmbedded]="true"
      [forceNarrow]="true"
      [hideFullscreenButton]="true"
      class="block h-full w-full"
    ></sia-ai-chat>
  </div>
</div>
